/**
 * ResourceWerx API
 * An API for ResourceWerx Document Management System.
 *
 * Contact: dan.leder@supremegroup.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Resource space filter for schedule and performance calculations.
 */
export type ResourceSpaceEnum = 'All' | 'InternalOnly' | 'SubletOnly';

export const ResourceSpaceEnum = {
    All: 'All' as ResourceSpaceEnum,
    InternalOnly: 'InternalOnly' as ResourceSpaceEnum,
    SubletOnly: 'SubletOnly' as ResourceSpaceEnum
};

